import { BACKEND_URL } from './args';

export const BACKEND_API_URL = BACKEND_URL.transform({
  pathname: '/privacy/graphql',
}).href;
